var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: { "modal-dialog-size": "lg" },
    on: { hide: _vm.handleHide },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v("\n    " + _vm._s(_vm.$t("marketing-terms.title")) + "\n  "),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", [
              _c("span", { staticClass: "bold text-dark-grey" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("marketing-terms.welcome.marketingSection")) +
                    "\n      "
                ),
              ]),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("marketing-terms.welcome.offerSection")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _c(
                "a",
                {
                  attrs: {
                    target: "_blank",
                    rel: "noopener noreferrer",
                    href: "http://fightspam.gc.ca/eic/site/030.nsf/eng/home",
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("marketing-terms.antiSpamLaw.link")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("marketing-terms.antiSpamLaw.text")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("h6", { staticClass: "text-uppercase bold" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("marketing-terms.liability.title")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("marketing-terms.liability.text")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("h6", { staticClass: "text-uppercase bold" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("marketing-terms.casl.title")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("marketing-terms.casl.text")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("h6", { staticClass: "text-uppercase bold" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("marketing-terms.cem.title")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "bullet" }, [
              _c("li", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("marketing-terms.cem.firstPoint")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("marketing-terms.cem.secondPoint")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("marketing-terms.cem.thirdPoint")) +
                    "\n      "
                ),
              ]),
            ]),
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("marketing-terms.cem.message")) +
                "\n    "
            ),
            _c("h6", { staticClass: "text-uppercase bold" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("marketing-terms.doubleOpt.title")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("marketing-terms.doubleOpt.text")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("h6", { staticClass: "text-uppercase bold" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("marketing-terms.exemptMessages.title")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("marketing-terms.exemptMessages.firstText"))
              ),
              _c("span", { staticClass: "bold" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("marketing-terms.exemptMessages.termsOfUse")
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "bullet" }, [
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("marketing-terms.exemptMessages.firstTerm"))
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("marketing-terms.exemptMessages.secondTerm"))
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("marketing-terms.exemptMessages.thirdTerm"))
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("marketing-terms.exemptMessages.fourthTerm"))
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("marketing-terms.exemptMessages.fifthTerm"))
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("marketing-terms.exemptMessages.sixthTerm"))
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("marketing-terms.exemptMessages.seventhTerm"))
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("marketing-terms.exemptMessages.eighthTerm"))
                  ),
                ]),
              ]),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("marketing-terms.exemptMessages.secondText")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("h6", { staticClass: "text-uppercase bold" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("marketing-terms.impliedVsExpressed.title")) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("marketing-terms.impliedVsExpressed.firstText")
                  ) +
                  " "
              ),
              _c("br"),
              _vm._v(" "),
              _c("span", { staticClass: "bold" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "marketing-terms.impliedVsExpressed.consentIncludesSection.title"
                    )
                  ) + "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "bullet" }, [
                _c("li", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(
                          "marketing-terms.impliedVsExpressed.consentIncludesSection.firstPoint"
                        )
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(
                          "marketing-terms.impliedVsExpressed.consentIncludesSection.secondPoint"
                        )
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(
                          "marketing-terms.impliedVsExpressed.consentIncludesSection.thirdPoint"
                        )
                      ) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "marketing-terms.impliedVsExpressed.consentIncludesSection.firstText"
                    )
                  ) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "marketing-terms.impliedVsExpressed.consentIncludesSection.secondText"
                    )
                  ) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _c("span", { staticClass: "bold" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "marketing-terms.impliedVsExpressed.consentValidSection.title"
                      )
                    ) +
                    "\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("ul", { staticClass: "bullet" }, [
                _c("li", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(
                          "marketing-terms.impliedVsExpressed.consentValidSection.firstPoint"
                        )
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(
                          "marketing-terms.impliedVsExpressed.consentValidSection.secondPoint"
                        )
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(
                          "marketing-terms.impliedVsExpressed.consentValidSection.thirdPoint"
                        )
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(
                          "marketing-terms.impliedVsExpressed.consentValidSection.fourthPoint"
                        )
                      ) +
                      "\n        "
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("marketing-terms.lastSection.firstText")) +
                  "\n      "
              ),
              _c("br"),
              _vm._v(
                _vm._s(_vm.$t("marketing-terms.lastSection.secondText")) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c("simple-button", {
              attrs: {
                text: _vm.$t("global.words.accept"),
                loading: _vm.loading,
                "loading-succeeded": _vm.loadingSucceeded,
              },
              on: { click: _vm.handleAccept },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }